export default "__VITE_ASSET__Bj1eYPJe__"